// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GameView_wrapper__PMZ-M","root":"GameView_root__35rvY","grid":"GameView_grid__1KYoy","gridInner":"GameView_gridInner__2SuZA"};